const LogoFull = () => {
  return (
    <img
      src="/oneadvanced-logo.svg"
      alt="OneAdvanced"
      style={{ width: 175, height: 'auto', display: 'block' }}
    />
  );
};

export default LogoFull;
